// 9fbef606107a605d69c0edbcd8029e5d
import { dyPageGroups, dyPageTypes } from './constants';
import { getPageTypeFromUrl } from '../../../../../utils/utils.web';

const dyRequestContextMap = {
  homepage: (payload = {}) => ({
    groups: dyPageGroups.HOME,
    pageType: dyPageTypes.HOME,
    pageName: 'homepage',
    ...payload,
  }),

  plp: (payload = {}) => ({
    groups: dyPageGroups.PLP,
    pageType: dyPageTypes.PLP,
    pageName: 'plp',
    ...payload,
  }),

  pdp: (payload = {}) => ({
    groups: dyPageGroups.PDP,
    pageType: dyPageTypes.PDP,
    pageName: 'pdp',
    ...payload,
  }),

  search: (payload = {}) => ({
    groups: dyPageGroups.SEARCH,
    pageType: dyPageTypes.SEARCH,
    pageName: 'search',
    ...payload,
  }),

  cart: (payload = {}) => ({
    groups: dyPageGroups.CART,
    pageType: dyPageTypes.CART,
    pageName: 'cart',
    ...payload,
  }),

  checkout: (payload = {}) => ({
    groups: dyPageGroups.CHECKOUT,
    pageType: dyPageTypes.CHECKOUT,
    pageName: 'checkout',
    ...payload,
  }),

  outfit: (payload = {}) => ({
    groups: dyPageGroups.OUTFIT,
    pageType: dyPageTypes.OUTFIT,
    pageName: 'outfit',
    ...payload,
  }),

  other: (payload = {}) => ({
    groups: dyPageGroups.HOME,
    pageType: dyPageTypes.OTHER,
    pageName: 'other',
    ...payload,
  }),
};

export const getDyRequestContextByPage = (url = window?.location?.pathname || '') => {
  const pageName = getPageTypeFromUrl(url);
  const contextFunction = dyRequestContextMap[pageName] || dyRequestContextMap.homepage;
  return contextFunction();
};

export default dyRequestContextMap;
